export const SET_CLIENT_POSITION = 'SET_CLIENT_POSITION';

export const GET_EVENT_REQUEST = 'GET_EVENT_REQUEST';
export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS';
export const GET_EVENT_FAILURE = 'GET_EVENT_FAILURE';

export const GET_TEAM_REQUEST = 'GET_TEAM_REQUEST';
export const GET_TEAM_SUCCESS = 'GET_TEAM_SUCCESS';
export const GET_TEAM_FAILURE = 'GET_TEAM_FAILURE';
export const UPDATE_TEAM_STATISTICS = 'UPDATE_TEAM_STATISTICS';

export const SET_ACTIVE_EVENT = 'SET_ACTIVE_EVENT';
export const SET_ACTIVE_TEAM = 'SET_ACTIVE_TEAM';
export const SET_ACTIVE_POINT = 'SET_ACTIVE_POINT';
export const CLOSE_ACTIVE_POINT = 'CLOSE_ACTIVE_POINT';

export const SET_ACTIVE_POINT_ANSWER = 'SET_ACTIVE_POINT_ANSWER';

export const SEND_ANSWER_REQUEST = 'SEND_ANSWER_REQUEST';
export const SEND_ANSWER_SUCCESS = 'SEND_ANSWER_SUCCESS';
export const SEND_ANSWER_FAILURE = 'SEND_ANSWER_FAILURE';

export const USER_MEDIA_REQUEST = 'USER_MEDIA_START';
export const USER_MEDIA_SUCCESS = 'USER_MEDIA_SUCCESS';
export const USER_MEDIA_FAILURE = 'USER_MEDIA_FAILURE';
export const SET_CAPTURED_MEDIA = 'SET_CAPTURED_MEDIA';

export const QUEUE_UPLOAD = 'QUEUE_UPLOAD';
export const UPLOAD_REQUEST = 'UPLOAD_REQUEST';
export const UPLOAD_FAILURE = 'UPLOAD_REQUEST';
export const UPLOAD_SUCCESS = 'UPLOAD_REQUEST';

export const MEDIA_CAPTURE_REQUEST = 'MEDIA_CAPTURE_START';
export const MEDIA_CAPTURE_SUCCESS = 'MEDIA_CAPTURE_SUCCESS';
export const MEDIA_CAPTURE_FAILURE = 'MEDIA_CAPTURE_FAILURE';


// WEBPACK FOOTER //
// ./src/store/mutation_types.js